import { useEffect, useState } from 'react';
import GridOptions from './GridOptions';
import MuiGrid from '../../../UI/MuiGrid/MuiGrid';
import { icons } from '../../../../../shared/icons';
import { formatPrice } from '../../../../../utils/FormatPrice';

const GridProvider = ({
  data,
  handleOpenDeleteDialog,
  handleEditData,
  opetPicture,
  loading,
}) => {
  const columns = [
    {
      field: 'id',
      disableExport: true,
      headerName: 'Options',
      width: 70,
      sortable: false,
      filterable: false,
      renderCell: (e) => (
        <GridOptions
          handleOpenDialog={() => handleOpenDeleteDialog(e.id)}
          getEditData={() => handleEditData(e.row)}
          opetPicture={() => opetPicture(e.row)}
        >
          <div>
            <button className="header-options">{icons.MENU_ICON}</button>
          </div>
        </GridOptions>
      ),
    },
    { field: 'naziv', headerName: 'Name', width: 200 },
    { field: 'opis', headerName: 'Description', width: 200 },
    { field: 'partNumber', headerName: 'Part number', width: 200 },
    { field: 'nazivMasine', headerName: 'Machine', width: 200 },
    {
      field: 'nazivKategorijeDela',
      headerName: 'Part category name',
      width: 200,
    },
    {
      field: 'nabavnaCena',
      headerName: 'Nabavna cena',
      width: 200,
      align: 'right',
      renderCell: (params) => (
        <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
          {formatPrice(params.value)}
        </span>
      ),
    },
    {
      field: 'marzaView',
      headerName: 'Marža',
      width: 200,
      align: 'right',
      renderCell: (params) => (
        <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
          {formatPrice(params.value)}
        </span>
      ),
    },
    {
      field: 'prodajnaCena',
      headerName: 'Prodajna cena',
      width: 200,
      align: 'right',
      renderCell: (params) => (
        <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
          {formatPrice(params.value)}
        </span>
      ),
    },
    { field: 'akcija', headerName: 'Akcija', type: 'boolean', width: 120 },
    { field: 'favorit', headerName: 'Favorit', type: 'boolean', width: 120 },
  ];
  return (
    <div>
      {' '}
      <div style={{ height: '75vh', width: '99%' }}>
        <MuiGrid data={data} columns={columns} loading={loading} />
      </div>
    </div>
  );
};

export default GridProvider;
